import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchNickName, FetchNickNameParams } from '../../api/fetchers/nickName';

export const fetchNickNameAction = createAsyncThunk('player/fetchNickName', (params: FetchNickNameParams) =>
  fetchNickName(params)
);
